import { useNavigate } from 'hooks';
import { formatDate } from 'utils/date';
import { Flex, Avatar, ListCard } from 'components';
import { formatPhone, joinStrings } from 'utils/helpers';

import { CardProps } from './types';
import { titles, cellsMobile } from './config';

export const Card = ({ data, getDetailsPath }: CardProps) => {
  const navigate = useNavigate();

  return (
    <ListCard
      headers={titles}
      cellsMobile={cellsMobile}
      onClick={() => navigate(getDetailsPath?.(data.id) || String(data.id))}
      values={[
        <Flex gap={16} alignItems="center">
          <Avatar size={56} url={data?.person?.photoUrl} />
          <p>
            {data?.person?.firstName} {data?.person?.lastName}
          </p>
        </Flex>,
        joinStrings(
          data?.employees?.map((employee) => employee?.name) || [],
          ', '
        ),
        data?.event?.name,
        formatPhone(data?.person?.phone),
        data?.person?.email,
        formatDate(data?.registered),
      ]}
    />
  );
};
